import React from "react";
import { AdvancedResearches } from "advancedResearches/AdvancedResearches";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import { observer } from "mobx-react";
import { URLS } from "_configs/URLS";
import { isBuyingPage } from "_common/_utils/pageUtils";
import { useLocation } from "react-router-dom";
import { useGetSearchFiltersFromUrl, useSearchPageParams } from "_common/_utils/hookUtils";

export const AdvancedResearchesSrPsProvinces = observer(() => {
    const location = useLocation();
    void geoZonesStore.fetchProvinces();
    const { garageParams } = useSearchPageParams();

    if (!geoZonesStore.provinces) return null;

    const filteredUrl = useGetSearchFiltersFromUrl();

    const purpose = isBuyingPage(location.pathname) ? "buy" : "rent";
    const sortedProvinces = [...geoZonesStore.provinces].sort((a, b) => a.name.localeCompare(b.name));

    return (
        <AdvancedResearches
            links={sortedProvinces.map((province) => ({
                to: URLS[purpose](undefined, province.address.province.toLowerCase(), garageParams) + filteredUrl,
                label: province.name.split(",")[0],
            }))}
        />
    );
});
